export default __webpack_public_path__ + "static/favicon-af94a8c1146655c963db2d827fe250f0.png";